module.exports = __webpack_public_path__ + "static/media/technician.b29fe92b.png";